const configuracion =
  window.location.hostname === "admin.cemtrik.com"
    ? require("./prod.js")
    : require("./dev.js");
export default configuracion;
